export default {


  // Init
  SET_GROUPS (state, groups) { state.groups = groups },
  SET_QUARTERS (state, quarters) { state.quarters = quarters },
  SET_BACKTESTS (state, backtests) { state.backtests = backtests },
  SET_INSIDER_ALERTS (state, alerts) { state.insider_alerts = alerts },
  SET_SECTORS (state, sectors) { state.sectors = sectors },
  SET_EMAIL_ALERTS (state, email_alerts) { state.email_alerts = email_alerts },
  SET_CLASSIFICATIONS (state, classifications) { state.classifications = classifications },
  SET_COUNTRIES (state, countries) { state.countries = countries },
  SET_SEC_CODE_STATES (state, sec_code_states) { state.sec_code_states = sec_code_states },
  SET_STATES (state, states) { state.states = states },
  SET_WW_GROUPS (state, ww_groups) { state.ww_groups = ww_groups },
  SET_OWNERSHIP_T_CODES (state, ownershiptcodes) { state.ownershiptcodes = ownershiptcodes },
  SET_USER (state, user) {
    if (!user) return

    state.user = user

    let today = new Date()
    let yesterday = today.setDate(today.getDate() - 1)

    if (user.subscription_limit && (user.subscription_limit.allowed_team_members > 0 || user.primary_account)) {
      state.is_team_member = true
    }

    if (user.user_subscription) {
      var d = new Date(user.user_subscription.subscription_end_date)
      state.is_subscriber = d >= yesterday
    }

    if (state.is_subscriber) {
      state.limit = 50
      if (user.user_subscription.subscription_type_id == 2) { state.is_pro_subscriber = true } else if (user.user_subscription.subscription_type_id == 3) {
        state.is_enterprise_subscriber = true
        state.limit = 9999
      }
      if (user.subscription_limit) {
        state.limit = user.subscription_limit.report_filer_limit
      }
    }

    if (user.primary_account) {
      var d = new Date(user.primary_account.user_subscription.subscription_end_date)

      state.is_subscriber = d >= yesterday
      if (state.is_subscriber) {
        if (user.primary_account.subscription_limit) {
          state.limit = user.primary_account.subscription_limit.report_filer_limit
        }
        if (user.primary_account.user_subscription.subscription_type_id == 2) { state.is_pro_subscriber = true } else if (user.primary_account.user_subscription.subscription_type_id == 3) {
          state.is_enterprise_subscriber = true
          state.limit = 9999
        }
      } else {
        state.limit = 5
        state.is_enterprise_subscriber = false
        state.is_pro_subscriber = false
      }
    }
  }
}
